<template>
  <div>
    <h3 @click="enableDebug($event)" class="display-4">
      Manage Service Recharge Bill Tos
    </h3>

    <o-list-toolbar
      :filters-list="filter_list"
      :list-options="list_options"
      :new-to="{ name: 'service_recharge_bill_to.create', params: { id: 0 } }"
      :query-select-options="options"
      :schema="schema"
      :search-fields-list="search_field_list"
      :selected-filter="selected_filter"
      @filter_changed="update_filter($event)"
      @options_changed="update_table($event)"
      @reset_table="reset_table"
      new-button-text="New Service Recharge Bill To"
    >
      <template slot="middle">
        <o-list-multi-actions
          :schema="schema"
          :selection="selected"
          @delete="doDeleteItems"
          @merge="doMergeItems"
          enable-delete
          enable-merge
        />
      </template>
    </o-list-toolbar>

    <b-table
      :fields="fields"
      :items="items"
      :sort-by="list_options.sort"
      :sort-desc="list_options.order == 'desc'"
      @row-selected="onRowSelected"
      @sort-changed="change_sort"
      bordered
      class="o-list"
      head-variant="light"
      no-local-sorting
      :selectable="selected.selectable"
      :key="selected.selectable"
      striped
      thead-class="o-gradient-header"
    >
      <template v-slot:cell(_selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
      </template>
      <template slot="cell(sub_contractor_name)" slot-scope="{ index, item }">
        <router-link
          :to="{
            name: 'service_recharge_bill_to.edit',
            params: { id: item.id },
          }"
        >
          <default-display :value="item.sub_contractor_name"></default-display>
        </router-link>
      </template>
      <template slot="cell(cost)" slot-scope="{ index, item }">
        <number-display :decimals="2" :value="item.cost" />
      </template>
      <template slot="cell(bill_no)" slot-scope="{ index, item }">
        <default-display :value="item.bill_no"></default-display>
      </template>
      <template slot="cell(bill_date)" slot-scope="{ index, item }">
        <date-display
          :value="item.bill_date"
          format="DD/MM/YYYY"
        ></date-display>
      </template>
      <template slot="cell(is_declined)" slot-scope="{ index, item }">
        <boolean-display :value="item.is_declined"></boolean-display>
      </template>

      <template #cell(crew_supplier__name)="{ index, item }">
        <router-link
          :to="{
            name: 'service_recharge_bill_to.edit',
            params: { id: item.id },
          }"
        >
          <router-link
            :to="{
              name: 'service_recharge_bill_to.edit',
              params: { id: item.id },
            }"
            :when="first_column_key === 'crew_supplier'"
          >
            <default-display
              :value="item.crew_supplier__name"
            ></default-display>
          </router-link>
        </router-link>
      </template>

      <template slot="empty">
        <p>
          <emoticon-sad-icon large></emoticon-sad-icon>
        </p>
        No Data Found. Please
        <router-link :to="{ name: 'service_recharge_bill_to.create' }"
          >create a new item</router-link
        >
      </template>
    </b-table>

    <o-list-paging
      :limit="list_options.limit"
      :offset="list_options.offset"
      :page-options="rows_per_page_items"
      :total-items="total_items"
      @change-limit="change_limit"
      @change-page="change_page"
    />
  </div>
</template>

<style></style>

<script>
import {
  CreateCodeTableFetchMixin,
  CreateGroupPermissionMixin,
  CreateListPageMixin,
  MultiActionsMixin,
} from "../../../vue-ocom/mixins";
import {
  fieldToTableColumn,
  GetSearchFields,
} from "../../../vue-ocom/schema/schema_utils";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import schema from "../../schema/index";

import OListToolbar from "../../../vue-ocom/components/list/OListToolbar";
import OListPaging from "../../../vue-ocom/components/list/OListPaging";
import DefaultDisplay from "../../../vue-ocom/components/display/DefaultDisplay";
import DateDisplay from "../../../vue-ocom/components/display/DateDisplay";
import NumberDisplay from "../../../vue-ocom/components/display/NumberDisplay";
import BooleanDisplay from "../../../vue-ocom/components/display/BooleanDisplay";
import LookupDisplay from "../../../vue-ocom/components/display/LookupDisplay";
import EmoticonSadIcon from "vue-material-design-icons/EmoticonSad";
import EmailIcon from "vue-material-design-icons/Email";
import LinkIcon from "vue-material-design-icons/Link";
import CrewSupplierMixin from "../../../mixins/CrewSupplierMixin";

export default {
  components: {
    EmoticonSadIcon,
    EmailIcon,
    LinkIcon,
    OListPaging,
    OListToolbar,
    DateDisplay,
    DefaultDisplay,
    BooleanDisplay,
    NumberDisplay,
    LookupDisplay,
  },
  mixins: [
    CreateListPageMixin("ServiceRechargeBillTo", "service_recharge_bill_to"),
    MultiActionsMixin,
    CreateGroupPermissionMixin("ServiceRechargeBillTo"),
    CreateCodeTableFetchMixin(["Supplier"]),
    CrewSupplierMixin(),
  ],
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.ServiceRechargeBillTo,
        {}
      ) /*Use this.schema instead */,

      search_field_list: GetSearchFields(schema.ServiceRechargeBillTo),

      filter_list: [
        { name: "Active", code: "active", options: { offset: 0, sort: "id" } },
        {
          name: "Non Active",
          code: "inactive",
          options: { offset: 0, sort: "id" },
        },
        { name: "All", code: "all", options: { offset: 0, sort: "id" } },
      ],
    };
  },
  computed: {
    options() {
      return {
        Crew: {
          options: this.optionCrewItems,
          textField: "name",
          valueField: "id",
        },
      };
    },
    fields() {
      return this.addSelectionColums(
        this.filterTableColumns(this.schema, [
          fieldToTableColumn(this.schema, "crew_supplier__name"),
          fieldToTableColumn(this.schema, "cost"),
          fieldToTableColumn(this.schema, "bill_no"),
          fieldToTableColumn(this.schema, "bill_date"),
          fieldToTableColumn(this.schema, "is_declined"),
        ])
      );
    },
  },
};
</script>
